import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-button-panel/jb-button-panel.css.ts
var jb_button_panel_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{display:block}div{align-items:center;display:flex;flex:var(--flex, 0 1 auto);flex-wrap:var(--panel-wrap, wrap);gap:var(--panel-gap, var(--theme-spacing-s));white-space:var(--white-space, nowrap)}div.left-aligned{justify-content:flex-start}div.right-aligned{justify-content:flex-end}div.center-aligned{justify-content:center}`;

export {
  jb_button_panel_css_default
};
